import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { Box } from '@mui/material'
import { useProject } from '../context/ProjectContext'
import Header from "../components/Header"
import Sidebar from "../components/Sidebar"
import BreadcrumbsNav from '../components/BreadcrumbsNav'
import TestCasesContent from '../components/testCases/TestCasesContent'
import PageService from "../services/PageService";

const TestCases = () => {
  const [testCasesHierarchicalData, setTestCasesHierarchicalData] = useState([])
  const [testCasesToggler, setTestCasesToggler] = useState(false)
  const [loading, setLoading] = useState(false)

  const { selectedProject } = useProject()

  useEffect(() => {
    const fetchHierarchy = async () => {
      if (!selectedProject?.id) {
        setTestCasesHierarchicalData([])
        return
      }
      setLoading(true)
      try {
        const data = await PageService.getTestCaseHierarchy(selectedProject.id)
        setTestCasesHierarchicalData(data)
      } catch (error) {
        console.error("Error fetching test case hierarchy:", error)
        setTestCasesHierarchicalData([])
      } finally {
        setLoading(false)
      }
    }

    fetchHierarchy()
  }, [selectedProject?.id, testCasesToggler])

  return (
    <Box className="rootWrapper">
      <Helmet>
        <title>{`Treegress - ${selectedProject?.name || "Project"} Test Cases`}</title>
      </Helmet>
      <Header />
      <Box className="srollContent">
        <Sidebar />
        <Box className='testCases'>
          <BreadcrumbsNav pageLabel="testCases"/>
          <TestCasesContent
            selectedProject={selectedProject}
            testCases={testCasesHierarchicalData}
            setTestCasesToggler={setTestCasesToggler}
            loading={loading}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default TestCases
